import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        setTimeout(() => {
            this.call('scrollTo', [this.el, { duration: 300, offset: -100 }], 'Scroll')
        }, 1500)
    }
}
